<script>
	let { message = "We're having trouble loading this content. Please try again in a moment." } = $props();
</script>

<div class="flex flex-col items-center justify-center py-20 text-center">
	<p class="max-w-md font-body text-navy-muted">{message}</p>
	<button onclick={() => location.reload()} class="mt-6 text-sm font-medium text-wine hover:text-wine-dark">
		Try again
	</button>
</div>
